import React, { useState } from "react";
import "./Leaves.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import LeaveApplicationLayout from "../layouts/Employee/LeaveApplicationLayout";

export default function Leaves() {
  return (
    <div className="overtime-application-bg">
      <Header />
      <SubHeader />
      <LeaveApplicationLayout />
    </div>
  );
}
